import logo from "../../assets/images/logo.svg";
import Menu from "./Menu";
import Search from "./Search";

const Navbar = () => {
  return (
    <nav className="py-4 2xl:px-6">
      <div className="container flex items-center justify-between">
        <img src={logo} width="150px" className="object-contain" alt="logo" />

        <Menu />

        <Search />
      </div>
    </nav>
  );
};

export default Navbar;
